import { isNull } from 'lodash';
import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class OfficerService extends AbstractService {
	static setup(baseURL, options) {
		instance = new OfficerService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoints = {
			officers        : APIEndpoints.officers,
			officerOverview : APIEndpoints.officerOverview,
			officerRating   : APIEndpoints.officerRating,
		};
	}

	static getAll(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getAll(...params);
	}

	static getById(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getById(...params);
	}

	static getReport(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getReport(...params);
	}

	static exportReport(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._exportReport(...params);
	}

	static checkOfficerRating(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._checkOfficerRating(...params);
	}

	static getOfficerRating(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getOfficerRating(...params);
	}

	static saveOfficerRating(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._saveOfficerRating(...params);
	}

	_getAll(queryParams) {
		return this.get({
			endpoint : this.endpoints.officers,
			queryParams,
		});
	}

	_getById(id, queryParams) {
		return this.get({
			queryParams,
			endpoint : `${this.endpoints.officers}/${id}`,
		});
	}

	_getReport(queryParams) {
		return this.get({
			endpoint : this.endpoints.officerOverview,
			queryParams,
		});
	}

	_exportReport(queryParams, data) {
		return this.post({
			endpoint : `${this.endpoints.officerOverview}/exportreport`,
			queryParams,
			data,
		});
	}

	_getOfficerRating(queryParams) {
		return this.get({
			endpoint : this.endpoints.officerRating,
			queryParams,
		});
	}

	_checkOfficerRating(queryParams) {
		return this.get({
			endpoint : `${this.endpoints.officerRating}/exists`,
			queryParams,
		});
	}

	_saveOfficerRating(data) {
		return this.post({
			endpoint : this.endpoints.officerRating,
			data,
		});
	}
}
